module.exports = __webpack_public_path__ + "static/media/SlatePro-Bk.c750f74d.woff";